import { render, staticRenderFns } from "./ksqpxblist.vue?vue&type=template&id=707b8189&scoped=true"
import script from "./ksqpxblist.vue?vue&type=script&lang=js"
export * from "./ksqpxblist.vue?vue&type=script&lang=js"
import style0 from "./ksqpxblist.vue?vue&type=style&index=0&id=707b8189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b8189",
  null
  
)

export default component.exports